export const REVEAL_UNAVAILABLE = "There isn't an upcoming reveal to sign up for right now. Please check back soon.";
export const REVEAL_EXPIRED = "This reveal is no longer available for signup. Refresh the page to see the next reveal.";
export const REVEAL_SUCCESS = "You're on the list! We’ll email you this pet’s real name after the reveal.";

export function upcomingReveal(state) {
  const poll = state?.current;
  const now = Date.parse(state?.now);
  if (!poll?.id || poll.status !== "voting" || !Number.isFinite(now) || !(Date.parse(poll.revealAt) > now)) return null;
  return poll;
}

export function revealScheduleLabel(poll) {
  if (!poll) return "";
  const date = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/New_York", weekday: "short", month: "short", day: "numeric",
  }).format(new Date(poll.revealAt));
  return `Daily Pet ${String(poll.publicNumber).padStart(4, "0")} · Reveal: ${date}`;
}
